module.exports = __webpack_public_path__ + "static/media/logo.6f59c9e1.svg";